export default {
  ADD_DATA_FOR_CLIENTS (state, data) {
    state.dataForClients = data
  },
  ADD_NEW_DATA_FOR_CLIENTS (state, dataItem) {
    state.dataForClients.push(dataItem)
  },
  DELETE_DATA_FOR_CLIENTS (state, id) {
    state.dataForClients = state.dataForClients.filter(s => s.id !== id)
  },
  CHANGE_DATA_FOR_CLIENTS_FILE (state, updatedData) {
    const currentData = state.dataForClients.find(s => s.id === updatedData.id)
    currentData.file = updatedData.file
  },
  UPDATE_DATA_FOR_CLIENTS (state, updatedData) {
    Object.assign(state.dataForClients.find(d => d.id === updatedData.id), updatedData)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/dataForClients.js